import Vuex from 'vuex';
import authModule, { AuthState } from '@/store/auth';
import storageModule, { StorageState } from '@/store/storage';
import collectionModule, { CollectionState } from '@/store/collection';

export interface RootState {
	auth: AuthState;
	storage: StorageState;
	collection: CollectionState;
}

export default new Vuex.Store<RootState>({
	modules: {
		auth: authModule,
		storage: storageModule,
		collection: collectionModule,
	},
});
